import { render, staticRenderFns } from "./EditSECReportModal.vue?vue&type=template&id=4c632c62"
import script from "./EditSECReportModal.vue?vue&type=script&lang=js"
export * from "./EditSECReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports